import { z } from "zod";

const translationPath = "page.register.companies.errors.";

const companyGroupSchema = z.object(
  {
    id: z.string(),
    name: z.string(),
    code: z.string().optional().nullable(),
  },
  { invalid_type_error: translationPath + "company_group" }
);

export const companySchema = z.object({
  id: z.string().optional(),
  code: z.string().nonempty(translationPath + "code"),
  name: z.string().nonempty(translationPath + "name"),
  enable: z.boolean(),
  companyGroup: companyGroupSchema,
});

export type TCompanyForm = z.infer<typeof companySchema>;
